module.exports = __webpack_public_path__ + "static/media/gold.f4744b9d.svg";